import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import translations from '../../constants/translations';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory({ forceRefresh: true });

function AssistanceRequestSuccess() {

  const language = history.location.state?.language;
  const successMessage = _.get(translations, `${language}.success`);

  return (
    <div className="text-center" style={{ padding: '2em' }}>
      <h2 className="font-bold text-xl">
        {successMessage.success}
      </h2>
      <p>
        {successMessage.thankYou}
      </p>
      <p>
        <a className="font-bold" href={history.location.state?.consent}>{successMessage.downloadConsent}</a>
      </p>
    </div>
  );
}

export default AssistanceRequestSuccess;
